import axios from 'axios'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Ensure TypeScript recognizes Pusher globally
declare global {
  interface Window {
    Pusher: typeof Pusher
    Echo: Echo<any>
  }
}
window.Pusher = Pusher
window.Echo = new Echo({
  broadcaster: 'reverb',
  key: 'c5eqva3tyckrnj324we9',
  appId: '794196',
  authorizer: (channel) => {
    return {
      authorize: (socketId: string, callback: (error: boolean, data: any) => void) => {
        axios
          .post(
            '/api/broadcasting/auth',
            {
              socket_id: socketId,
              channel_name: channel.name,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
              },
            }
          )
          .then((response) => {
            // console.log('Auth success:', response)
            callback(false, response.data)
          })
          .catch((error) => {
            // console.error('Auth error:', error)
            callback(true, error)
          })
      },
    }
  },
  wsHost: 'portal.swiss-umef.ch',
  wsPort: 8080,
  // wssPort: 443, 
  forceTLS: false,
  enabledTransports: ['ws'],
})
export default window.Echo
